import { useMemo } from "react";
import { useGetMarketPenetrationOverTime } from "../../../../hooks/useGetMarketPenetrationOverTime";
import { BaseDateChartData } from "../../../../../../components/charts/BaseDateDataChart/types";
import { transformToChartData } from "../utils/transformToChartData";
import { QueryVariables } from "../../../../../../apis/companySearch/marketPenetrationOverTime";
import useMatchProductsById from "../../hooks/useMatchProductsById";
import { useWorkspaceStore } from "../../../../../../store/workspace/WorkspaceStore";

export function useGetChartData({
  companyFilters,
  productIds,
  localizeInstalls = false,
  lookbackYears = 1,
}: QueryVariables) {
  const { matchedProductsById } = useMatchProductsById(productIds);
  const workspaceWhitespace = useWorkspaceStore(
    (state) => state.draft?.configuration?.whitespace
  );

  const { data: rawData, loading } = useGetMarketPenetrationOverTime({
    companyFilters,
    productIds,
    localizeInstalls,
    lookbackYears,
    companyMatchFile:
      companyFilters?.opportunityType &&
      workspaceWhitespace?.fileId &&
      workspaceWhitespace?.lastMatched
        ? workspaceWhitespace
        : undefined,
  });

  const data = useMemo<BaseDateChartData[]>(() => {
    if (!rawData || rawData.length === 0) return [];

    const productNameMap = new Map(
      matchedProductsById.map((product) => [product.id, product.name])
    );

    return transformToChartData(rawData, productNameMap);
  }, [rawData, matchedProductsById]);

  return {
    loading,
    data,
  };
}
